import Rings from "./Rings"
import Gate from "./Gate"
import Ship from "./Ship"
import Alert from "./Alert"
import Elevator from "./Elevator"
import Moons from "./Moons"
import Station from "./Station"
import Anomaly from "./Anomaly"
import { TerrestrialNumbers } from "./TerrestrialNumbers"
import ExtraMoons from "./ExtraMoons"
import Blockade from "./Blockade"

const PointsOfInterest = (props) => {
  const { poiNums, planetcolors, gaseous, orbitalTag, blockade } = props
  const { planetNum, moonNum, ringNums, extraMoons, gateNum,
  elevatorNum, shipNum, anomalyNum, alertNum, stationNum } = poiNums

  return (
    <svg viewBox="0 0 4000 4000" {...props}>
      {(() => {
        switch(orbitalTag) {
          case 'moon':
            return <Moons num={moonNum} orbitcolor={planetcolors.ocean} />
          case 'rings':
            return <Rings ringNums={ringNums} planetcolors={planetcolors} />
          case 'alert':
            return <Alert num={alertNum} />
          case 'anomaly':
            return <Anomaly num={anomalyNum} orbitcolor={planetcolors.ocean} />
          case 'ship':
            return <Ship num={shipNum} />
          case 'elevator':
            return <Elevator num={elevatorNum} colors={planetcolors} />
          case 'station':
            return <Station num={stationNum} />
          case 'gate':
            return <Gate num={gateNum} />
          default:
            return null
        }
      })()}
      {!gaseous && <TerrestrialNumbers num={planetNum}/>}
      {(orbitalTag !== "moon") && <ExtraMoons num={extraMoons} orbitcolor={planetcolors.ocean} />}
      {blockade && <Blockade />}
    </svg>
  )
}

export default PointsOfInterest
